import { useEffect } from 'react'
import { useAuthStore } from '../stores/authStore'
import { useNavigate } from 'react-router-dom'
import { AlertCircle, LogOut } from 'lucide-react'

/**
 * Session Expired Modal
 * Toont een nette modal wanneer de sessie is verlopen
 */
function SessionExpiredModal({ isOpen, onClose }) {
  const logout = useAuthStore((state) => state.logout)
  const navigate = useNavigate()

  useEffect(() => {
    if (isOpen) {
      // Auto-logout na 5 seconden als gebruiker niet reageert
      const timeout = setTimeout(() => {
        handleLogout()
      }, 5000)

      return () => clearTimeout(timeout)
    }
  }, [isOpen])

  const handleLogout = () => {
    logout()
    navigate('/login', { 
      state: { 
        message: 'Uw sessie is verlopen door inactiviteit. Log opnieuw in om door te gaan.' 
      } 
    })
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-shrink-0">
            <AlertCircle className="w-8 h-8 text-orange-600" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900">Sessie Verlopen</h2>
            <p className="text-sm text-gray-600 mt-1">
              Uw sessie is verlopen door inactiviteit
            </p>
          </div>
        </div>
        
        <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-orange-800">
            U wordt automatisch uitgelogd voor uw veiligheid. Log opnieuw in om door te gaan.
          </p>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={handleLogout}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2 transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Opnieuw Inloggen
          </button>
        </div>
      </div>
    </div>
  )
}

export default SessionExpiredModal
